import React from 'react';
import { Field } from 'redux-form';
import { SelectInput, TextInput } from 'react-admin';

import PaceTypes from '../../StaticData/PaceTypes';
import PopoverHelp from '../Popovers/Help';

const PaceInputs = (props) => (
  <div>
    <Field
      component={TextInput}
      label="Pace %"
      name="pace"
      source="pace" /><br />
    <Field
      choices={PaceTypes}
      component={SelectInput}
      label="Pace Type"
      name="pace_type"
      source="pace" /><br />
    <div style={{ visibility: 'hidden' }}>
      <PopoverHelp content="Traffic: Campaign is targeted to the traffic and does not stick to a user.  User: Campaign is targeted to a user for the duration of their browsing session" />
    </div>
  </div>
);

export default PaceInputs;



// WEBPACK FOOTER //
// ./src/views/Common/Partials/PaceInputs.tsx